import { IconBase, IconComponent } from './BaseIcon';

export const Lovetab: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="m16 10-4.5-4.5L3 14l13 13 13-13-8.5-8.5L16 10m9 4-9 9-9-9 4.5-4.5L16 14l4.5-4.5L25 14Z" />
  </IconBase>
);
